import React, { Component } from 'react'
import { translate } from 'react-i18next'
import { func } from 'prop-types'
import { withRouter } from 'react-router'
import { stores, view } from '../../stores'
import { SubHero } from '../../components/header/SubHero'
import { PagesPaths } from '../../constants/Pages'
import { AvanceImmediateForm } from '../../components/customer/AvanceImmediateForm'
import { AvanceImmediateDetails } from '../../components/customer/AvanceImmediateDetails'
import { Loader } from '../../components/ui/states/Loader'

class AvanceImmediatePageComponent extends Component {
  componentWillMount () {
    stores.avanceImmediate.refreshInfos()
  }

  render () {
    const { t } = this.props
    const breadcrumb = [{ name: t('common:avance_immediate:title'), path: PagesPaths.AVANCE_IMMEDIATE.path }]
    return (
      <div>
        <SubHero breadcrumb={breadcrumb} />
        <div className='layout__container account'>
          <h2 style={{ fontWeight: 500 }}>{t('common:avance_immediate:title')}</h2>
          <div className='account__edit'>
            {stores.avanceImmediate.refreshing
              ? <Loader size='small' />
              : ((stores.avanceImmediate.infos && stores.avanceImmediate.infos.informationProvided)
                ? <AvanceImmediateDetails /> : <AvanceImmediateForm
                  lastAttemptInformation={stores.avanceImmediate.infos.lastAttemptInformation} />)}
          </div>
        </div>
      </div>
    )
  }
}

AvanceImmediatePageComponent.propTypes = {
  t: func
}

export const AvanceImmediatePage = withRouter(translate()(view(AvanceImmediatePageComponent)))



// WEBPACK FOOTER //
// ./src/pages/compte/AvanceImmediatePage.js